import { Clock, Wrench, ShieldCheck, Snowflake, Flame, Building2, Wind, Phone, Calendar, CheckCircle2, Star, ThermometerSun, Fan, Award } from 'lucide-react';

export const iconMap = {
  Clock, Wrench, ShieldCheck, Snowflake, Flame, Building2, Wind, Phone, Calendar, CheckCircle2, Star, ThermometerSun, Fan, Award
};

export const getIcon = (name) => iconMap[name] || Snowflake;
